<vb-dialog
  [(visible)]="visible"
  [header]="dialogHeader"
  size="medium"
  [closable]="true"
  [closeOnEscape]="true"
  (hide)="closeDialog()"
  (show)="onDialogShow()"
>
  <div class="env-url-dialog">
    <!-- Search Section -->
    <div class="search-section">
      <div class="filter-dropdown">
        <label class="filter-label" for="filterSelect">{{ 'FILTER_BY' | translate }}</label>
        <p-select
          id="filterSelect"
          [options]="filterOptions"
          [(ngModel)]="selectedFilter"
          (onChange)="filterEnvironments()"
          [style]="{'width': '150px'}"
          [appendTo]="'body'"
        ></p-select>
      </div>
      <vb-search-input
        [placeholder]="'SEARCH_ENV_OR_URL' | translate"
        [(value)]="searchString"
        (searchTriggered)="filterEnvironments()"
      ></vb-search-input>
    </div>

    <!-- Info Note -->
    <div class="info-note">
      <i class="pi pi-info-circle"></i>
      <span style="font-size: x-small;">{{ 'DEV_ENV_URL_MANDATORY_NOTE' | translate }}</span>
    </div>

    <!-- Environment URL Inputs -->
    <div class="env-url-list" [formGroup]="formGroup">
      <div class="env-url-row" *ngFor="let env of filteredEnvironments">
        <label class="env-label" [attr.title]="env.name">
          {{ env.name }}
          <span class="required-asterisk" *ngIf="env.purpose === 'DEVELOPMENT' && env.isSysGen">*</span>
        </label>
        <div class="url-input-container">
          <input
            #envUrlInput
            pInputText
            type="text"
            [id]="'env-url-' + env.name"
            [formControlName]="env.name"
            class="url-input"
            [class.is-invalid]="formGroup.get(env.name)?.invalid && formGroup.get(env.name)?.dirty"
            placeholder="{{ 'ENTER_URL' | translate }}"
          />
          <small class="error-message" *ngIf="formGroup.get(env.name)?.invalid && formGroup.get(env.name)?.dirty">
            {{ getErrorMessage(env.name) }}
          </small>
        </div>
      </div>

      <!-- Empty state message -->
      <div class="empty-state" *ngIf="filteredEnvironments.length === 0">
        <i class="pi pi-inbox empty-icon"></i>
        <span class="empty-text">{{ getEmptyMessage() }}</span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <vb-button-group>
      <vb-button
        [label]="'CANCEL' | translate"
        variant="secondary"
        [outlined]="true"
        (btnClick)="closeDialog()"
      ></vb-button>
      <vb-button
        [label]="'SAVE' | translate"
        variant="primary"
        [disabled]="disableField || hasErrors()"
        (btnClick)="saveAndClose()"
      ></vb-button>
    </vb-button-group>
  </ng-template>
</vb-dialog>
